import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// The API exposes only these two relationships, neither with a reciprocal inverse.
const MatchCertificationSchema = withDefaults({
  type: 'match-certification',
  fields: [
    {
      kind: 'belongsTo',
      name: 'matchPayment',
      type: 'match-payment',
      options: { async: false, inverse: null },
    },
    {
      kind: 'belongsTo',
      name: 'matchPeriod',
      type: 'match-period',
      options: { async: false, inverse: null },
    },
  ],
});

export default MatchCertificationSchema;
